let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

/* =====================================================================
 * NAKAMA · Arreglo del descuento/total en el cajon del carrito
 * 1) Tras cualquier cambio del carrito, vuelve a pedir el pie del cajon
 *    para que el descuento del codigo se recalcule (usa CartDrawer.refresh).
 * 2) Recalcula el TOTAL como (subtotal - descuentos), porque el tema lo
 *    calcula sumando lineas sin restar el codigo, y cart.total_price no
 *    incluye el codigo hasta el checkout. Se mantiene con un observer.
 * Si no hay codigo aplicado, no toca nada (deja el total del tema).
 * ===================================================================== */
(function () {
  if (window.__nakamaCartDiscountFix) return;
  window.__nakamaCartDiscountFix = true;

  function parseEuro(t) {
    if (!t) return 0;
    t = ('' + t).replace(/[^0-9,.-]/g, '').replace(/\./g, '').replace(',', '.');
    var n = parseFloat(t);
    return isNaN(n) ? 0 : n;
  }

  function formatEuro(amount) {
    var neg = amount < 0;
    var cents = Math.round(Math.abs(amount) * 100);
    var euros = Math.floor(cents / 100);
    var dec = ('0' + (cents % 100)).slice(-2);
    var intStr = String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (neg ? '-' : '') + intStr + ',' + dec + ' \u20ac';
  }

  function applyCorrectTotal() {
    var subEl = document.getElementById('cart-subtotal');
    var totalEl = document.getElementById('cart-total');
    if (!subEl || !totalEl) return;

    var discNodes = document.querySelectorAll('.cart-footer-discount-amount');
    if (!discNodes || discNodes.length === 0) return;

    var subtotal = parseEuro(subEl.textContent);
    var discounts = 0;
    discNodes.forEach(function (n) { discounts += Math.abs(parseEuro(n.textContent)); });
    if (discounts <= 0) return;

    var correct = formatEuro(subtotal - discounts);
    if (totalEl.textContent.trim() !== correct) {
      totalEl.textContent = correct;
    }
  }

  function installObserver() {
    var target = document.getElementById('cart-drawer') || document.body;
    try {
      var obs = new MutationObserver(function () { applyCorrectTotal(); });
      obs.observe(target, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }

  var origFetch = window.fetch;
  var pending = null;
  function onCartChanged() {
    if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
      window.CartDrawer.refresh({ keepOpen: true });
    }
    if (pending) clearTimeout(pending);
    pending = setTimeout(applyCorrectTotal, 150);
  }

  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var arg = arguments[0];
      var url = (arg && arg.url) ? arg.url : ('' + arg);
      var result = origFetch.apply(this, arguments);
      try {
        if (typeof url === 'string' &&
            (url.indexOf('/cart/change') !== -1 ||
             url.indexOf('/cart/add') !== -1 ||
             url.indexOf('/cart/update') !== -1)) {
          result.then(function () { onCartChanged(); }).catch(function () {});
        }
      } catch (e) {}
      return result;
    };
  }

  function init() { installObserver(); applyCorrectTotal(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
